import {
  receiveESignatureData,
  receiveSignmeRegistrationStatus
} from './esignature';
import { WEBSOCKET_TOPICS } from '../middleware/webSocket';
import {
  receiveCrossDeviceDocumentCompletedEvent,
  receiveSignatureFromMobile
} from './rootAction';

export const SUBSCRIBE_WEBSOCKET_TOPIC = 'SUBSCRIBE_WEBSOCKET_TOPIC';
export const UNSUBSCRIBE_WEBSOCKET_TOPIC = 'UNSUBSCRIBE_WEBSOCKET_TOPIC';
export const INIT_WEBSOCKET = 'INIT_WEBSOCKET';
export const WEBSOCKET_SET_STATUS = 'WEBSOCKET_SET_STATUS';

export function initWebSocket() {
  return { type: INIT_WEBSOCKET };
}

export function setWebSocketStatus(payload) {
  return { type: WEBSOCKET_SET_STATUS, payload };
}

export function subscribeWebSocket(topic, sid) {
  return {
    type: SUBSCRIBE_WEBSOCKET_TOPIC,
    topic,
    sid
  };
}

export function unSubscribeWebSocket(topic) {
  return {
    type: UNSUBSCRIBE_WEBSOCKET_TOPIC,
    topic
  };
}

export function onReceiveWebSocketMessage(message) {
  switch (message.topic) {
    case WEBSOCKET_TOPICS.SIGN_ON_MOBILE:
      return receiveSignatureFromMobile(message);
    case WEBSOCKET_TOPICS.CROSS_DEVICE_DOCUMENT_COMPLETED:
      return receiveCrossDeviceDocumentCompletedEvent(message);
    case WEBSOCKET_TOPICS.SIGNME_REGISTRATION:
      return receiveSignmeRegistrationStatus(message.processState);
    case WEBSOCKET_TOPICS.SIGNME_SINGING:
    case WEBSOCKET_TOPICS.YES_SINGING:
    case WEBSOCKET_TOPICS.ATRUST_SINGING:
      return receiveESignatureData(message);
    default:
      break;
  }
}
